import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import ContentHouse from './content-house-model'
import {
  CreateContentHouseAsync,
  DeleteContentHouseAsync,
  LoadContentHousesAsync,
} from './contentHouse-thunk'
const initialState: contentHouseSliceState = {
  contentHouse: [],
  selected_contentHouse: '',
  is_loading_contentHouse: false,
  is_creating_contentHouse: false,
  is_deleting_contentHouse: false,
}
export interface contentHouseSliceState {
  contentHouse: ContentHouse[]
  selected_contentHouse?: string
  is_loading_contentHouse: boolean
  is_creating_contentHouse: boolean
  is_deleting_contentHouse: boolean
}
export const contentHouseSlice = createSlice({
  name: 'contentHouse',
  initialState,
  reducers: {
    setSelectedcontentHouse: (state, action) => {
      state.selected_contentHouse = action.payload
    },
    clearStatecontentHouse: (state) => {
      state.contentHouse = []
      state.is_loading_contentHouse = false
      state.is_creating_contentHouse = false
      state.is_deleting_contentHouse = false
    },
    mergecontentHouse: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_contentHouse = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.contentHouse = merge(state.contentHouse, payload) as any
        }
      }
    },

    add_contentHouse: (state, action) => {
      if (action.payload) {
        state.contentHouse = [...state.contentHouse, action.payload]
      }
    },
    set_contentHouse: (state, action) => {
      let { key, value, id } = action.payload
      state.contentHouse = state.contentHouse.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadContentHousesAsync.pending, (state) => {
      state.is_loading_contentHouse = true
    })
    builder.addCase(LoadContentHousesAsync.fulfilled, (state, action) => {
      state.is_loading_contentHouse = false
      if (action.payload) {
        state.contentHouse = action.payload
      }
    })
    builder.addCase(LoadContentHousesAsync.rejected, (state) => {
      state.is_loading_contentHouse = false
    })
    builder.addCase(CreateContentHouseAsync.pending, (state) => {
      state.is_creating_contentHouse = true
    })
    builder.addCase(CreateContentHouseAsync.fulfilled, (state) => {
      state.is_creating_contentHouse = false
    })
    builder.addCase(CreateContentHouseAsync.rejected, (state) => {
      state.is_creating_contentHouse = false
    })
    builder.addCase(DeleteContentHouseAsync.pending, (state) => {
      state.is_deleting_contentHouse = true
    })
    builder.addCase(DeleteContentHouseAsync.fulfilled, (state, action) => {
      state.is_deleting_contentHouse = false
      if (state.contentHouse) {
        state.contentHouse = state.contentHouse.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteContentHouseAsync.rejected, (state) => {
      state.is_deleting_contentHouse = false
    })

    builder.addCase(autoThunks.get_pending_content_houses.pending, (state) => {
      state.is_loading_contentHouse = true
    })
    builder.addCase(
      autoThunks.get_pending_content_houses.fulfilled,
      (state, action) => {
        state.is_loading_contentHouse = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_pending_content_houses.rejected, (state) => {
      state.is_loading_contentHouse = false
    })

    builder.addCase(autoThunks.store_new_content_house.pending, (state) => {
      state.is_loading_contentHouse = true
    })
    builder.addCase(
      autoThunks.store_new_content_house.fulfilled,
      (state, action) => {
        state.is_loading_contentHouse = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.store_new_content_house.rejected, (state) => {
      state.is_loading_contentHouse = false
    })

    builder.addCase(
      autoThunks.load_existing_content_houses.pending,
      (state) => {
        state.is_loading_contentHouse = true
      },
    )
    builder.addCase(
      autoThunks.load_existing_content_houses.fulfilled,
      (state, action) => {
        state.is_loading_contentHouse = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.load_existing_content_houses.rejected,
      (state) => {
        state.is_loading_contentHouse = false
      },
    )

    builder.addCase(autoThunks.load_content_houses.pending, (state) => {
      state.is_loading_contentHouse = true
    })
    builder.addCase(
      autoThunks.load_content_houses.fulfilled,
      (state, action) => {
        state.is_loading_contentHouse = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.load_content_houses.rejected, (state) => {
      state.is_loading_contentHouse = false
    })

    builder.addCase(
      autoThunks.load_existing_content_houses_for_membership.pending,
      (state) => {
        state.is_loading_contentHouse = true
      },
    )
    builder.addCase(
      autoThunks.load_existing_content_houses_for_membership.fulfilled,
      (state, action) => {
        state.is_loading_contentHouse = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.load_existing_content_houses_for_membership.rejected,
      (state) => {
        state.is_loading_contentHouse = false
      },
    )

    builder.addCase(autoThunks.toggle_admin_for_user.pending, (state) => {
      state.is_loading_contentHouse = true
    })
    builder.addCase(
      autoThunks.toggle_admin_for_user.fulfilled,
      (state, action) => {
        state.is_loading_contentHouse = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.toggle_admin_for_user.rejected, (state) => {
      state.is_loading_contentHouse = false
    })

    builder.addCase(autoThunks.send_invitation_for_user.pending, (state) => {
      state.is_loading_contentHouse = true
    })
    builder.addCase(
      autoThunks.send_invitation_for_user.fulfilled,
      (state, action) => {
        state.is_loading_contentHouse = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.send_invitation_for_user.rejected, (state) => {
      state.is_loading_contentHouse = false
    })

    builder.addCase(autoThunks.cancel_invitee_invitation.pending, (state) => {
      state.is_loading_contentHouse = true
    })
    builder.addCase(
      autoThunks.cancel_invitee_invitation.fulfilled,
      (state, action) => {
        state.is_loading_contentHouse = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.cancel_invitee_invitation.rejected, (state) => {
      state.is_loading_contentHouse = false
    })

    builder.addCase(
      autoThunks.update_my_contenthouse_contentcreator_profile.pending,
      (state) => {
        state.is_loading_contentHouse = true
      },
    )
    builder.addCase(
      autoThunks.update_my_contenthouse_contentcreator_profile.fulfilled,
      (state, action) => {
        state.is_loading_contentHouse = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.update_my_contenthouse_contentcreator_profile.rejected,
      (state) => {
        state.is_loading_contentHouse = false
      },
    )

    builder.addCase(autoThunks.load_my_content_houses.pending, (state) => {
      state.is_loading_contentHouse = true
    })
    builder.addCase(
      autoThunks.load_my_content_houses.fulfilled,
      (state, action) => {
        state.is_loading_contentHouse = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.load_my_content_houses.rejected, (state) => {
      state.is_loading_contentHouse = false
    })

    builder.addCase(
      autoThunks.update_contenthouse_information.pending,
      (state) => {
        state.is_loading_contentHouse = true
      },
    )
    builder.addCase(
      autoThunks.update_contenthouse_information.fulfilled,
      (state, action) => {
        state.is_loading_contentHouse = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.update_contenthouse_information.rejected,
      (state) => {
        state.is_loading_contentHouse = false
      },
    )

    builder.addCase(
      autoThunks.get_content_houses_for_customer.pending,
      (state) => {
        state.is_loading_contentHouse = true
      },
    )
    builder.addCase(
      autoThunks.get_content_houses_for_customer.fulfilled,
      (state, action) => {
        state.is_loading_contentHouse = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_content_houses_for_customer.rejected,
      (state) => {
        state.is_loading_contentHouse = false
      },
    )

    builder.addCase(
      autoThunks.get_contenthouse_for_release_management_by_content_house
        .pending,
      (state) => {
        state.is_loading_contentHouse = true
      },
    )
    builder.addCase(
      autoThunks.get_contenthouse_for_release_management_by_content_house
        .fulfilled,
      (state, action) => {
        state.is_loading_contentHouse = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_contenthouse_for_release_management_by_content_house
        .rejected,
      (state) => {
        state.is_loading_contentHouse = false
      },
    )

    builder.addCase(
      autoThunks.get_contet_houses_for_release_management.pending,
      (state) => {
        state.is_loading_contentHouse = true
      },
    )
    builder.addCase(
      autoThunks.get_contet_houses_for_release_management.fulfilled,
      (state, action) => {
        state.is_loading_contentHouse = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_contet_houses_for_release_management.rejected,
      (state) => {
        state.is_loading_contentHouse = false
      },
    )

    builder.addCase(
      autoThunks.get_content_houses_for_curated_list.pending,
      (state) => {
        state.is_loading_contentHouse = true
      },
    )
    builder.addCase(
      autoThunks.get_content_houses_for_curated_list.fulfilled,
      (state, action) => {
        state.is_loading_contentHouse = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_content_houses_for_curated_list.rejected,
      (state) => {
        state.is_loading_contentHouse = false
      },
    )
  },
})

function handleResult(action: any, state: contentHouseSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_contentHouse = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.contentHouse = merge(state.contentHouse, payload) as any
    }
  }
}

export const {
  clearStatecontentHouse,
  setSelectedcontentHouse,
  set_contentHouse,
  mergecontentHouse,
  add_contentHouse,
} = contentHouseSlice.actions

export const get_contentHouse =
  (id?: string) =>
  (state: {
    contentHouse: {
      contentHouse: ContentHouse[]
    }
  }): ContentHouse | null => {
    let temp = state?.contentHouse?.contentHouse?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.contentHouse?.contentHouse[0] || null
  }
export const get_selected_contentHouse = (state: {
  contentHouse: contentHouseSliceState
}): ContentHouse | null => {
  let id = state?.contentHouse?.selected_contentHouse
  let temp = state?.contentHouse?.contentHouse?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_contentHouse = (state: {
  contentHouse: {
    contentHouse: ContentHouse[]
  }
}): ContentHouse[] => {
  let temp = state?.contentHouse?.contentHouse
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_contentHouse_busy = (state: {
  contentHouse: contentHouseSliceState
}) => {
  return (
    state?.contentHouse.is_deleting_contentHouse ||
    state?.contentHouse.is_loading_contentHouse ||
    state?.contentHouse.is_creating_contentHouse
  )
}
export const is_deleting_contentHouse_busy = (state: {
  contentHouse: contentHouseSliceState
}) => {
  return state?.contentHouse.is_deleting_contentHouse
}
export const is_loading_contentHouse_busy = (state: {
  contentHouse: contentHouseSliceState
}) => {
  return state?.contentHouse.is_loading_contentHouse
}
export const is_creating_contentHouse_busy = (state: {
  contentHouse: contentHouseSliceState
}) => {
  return state?.contentHouse.is_creating_contentHouse
}

export default contentHouseSlice.reducer
